import { render } from "./TermsAndCond.vue?vue&type=template&id=e790ea24"
import script from "./TermsAndCond.vue?vue&type=script&lang=js"
export * from "./TermsAndCond.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__